import { render, staticRenderFns } from "./dc-user.vue?vue&type=template&id=b0a9ea46&scoped=true"
import script from "./dc-user.vue?vue&type=script&lang=js"
export * from "./dc-user.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0a9ea46",
  null
  
)

export default component.exports